import { facadeApi } from 'api'
import { UpdateAppInstanceGroupsBulkDTO } from 'types/apps/appInstanceGroups'

interface Params {
  data: UpdateAppInstanceGroupsBulkDTO
}

export const editAppInstanceGroupsBulkApi = ({ data }: Params) =>
  facadeApi.patch<unknown>('/app-instances/groups/bulk', data)
